/**
 * Predicate and constants powering the "Update Applicant Info" CTA on the
 * Voucher Thank You page and the matching `applicant-update` mode of the
 * Voucher Form.
 *
 * Visibility rule (Onboarding-1, FR-1):
 *   show CTA <=> View/Edit CTA hidden AND Preview CTA available AND no OPP
 */

export const APPLICANT_UPDATE_MODE = "applicant-update";

export const canShowApplicantUpdateCTA = ({
  showViewEditButton,
  showPreviewiewButton,
  oppId,
} = {}) => !showViewEditButton && Boolean(showPreviewiewButton) && !oppId;
